import axios from '@/plugins/axios.js';

/**
 * Store rejected uploads for analytics. The request opts out of the axios retry and
 * Sentry reporting so a failed log never adds noise or delay to the upload it describes.
 *
 * @param {Array<Object>} rejections at most MAX_REJECTIONS_PER_REQUEST entries
 * @returns {Promise<void>}
 */
export async function storeFileUploadRejections(rejections) {
    await axios.post('/api/file-upload-rejections', { rejections }, { retry: false, errorHandle: false });
}
